import { CONTENT_REGIONS, CURRENCY_CONTENT_REGIONS } from "@/data/localisation";
import { TContentRegion } from "@/types/app";
import { toCurrencyCode } from "./toCurrencyCode";

/** The content region for a country, or `undefined` for the default. */
export const resolveContentRegion = (
  countryISO?: string,
): TContentRegion | undefined => {
  if (!countryISO) return undefined;

  return CONTENT_REGIONS[countryISO.toUpperCase()];
};

// The content region a plan's currency implies, for `/pricing/metadata`, which
// prices by region but returns no country.
export const resolveContentRegionFromCurrency = (
  currency?: string,
): TContentRegion | undefined => {
  // No DEFAULT_CURRENCY fallback: an unmapped symbol must not read as "not localised".
  const isoCode = toCurrencyCode(currency);

  if (!isoCode) return undefined;

  return CURRENCY_CONTENT_REGIONS[isoCode];
};
